
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wing/account",
      function () {
        return require("private-next-pages/wing/account/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wing/account"])
      });
    }
  